import { Services } from '@sigma-frontend-libs/commons'
import { EVENTSHISTORY_ASSOCIATED_SERVICES } from '@sigma-legacy-libs/essentials/lib/constants'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    service() {
      switch (this.value.service) {
        case EVENTSHISTORY_ASSOCIATED_SERVICES.keywordListsKeywords: {
          if ('regexp' in this.value.data) {
            return Services.keywords
          }

          return Services.keywordLists
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.contactListsContacts: return Services.contacts
        default: return this.value.service
      }
    }
  },

  methods: {
    clickHandler() {
      this.$emit('click')
    }
  },

  render
}
